<template>
  <div id="app">
      <router-view></router-view>
      <Footer/>
  </div>
</template>

<script>
import '@/assets/iconfont/iconfont.css'
import Footer from './common/Footer'
export default {
  name: 'app',
  components: {
    Footer
  },
  data() {
    return {
      status:0
    };
  },
  methods: {
    getBaseInfo(){
      this.$http({
        method: 'get',
        url: 'base_info'
      }).then(res=>{
        if(!localStorage.getItem('token')){
           this.$router.push({path:'/login'})
        }
        this.$store.commit('setBaseInfoValue', res.data);
      })
    }

  },
  created(){
    document.title = 'ツヴァイ'
    this.getBaseInfo();
  }
}
</script>

<style>
.header,.nav-bar {
    width: 100%;
    position: relative;
    position: fixed !important;
    top: 0px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 99;
}
.van-loading__text,.van-list__finished-text {
  font-size: 30px !important;
}
body .van-toast {
  font-size: 38px;
  padding: 30px;
  line-height: 50px;
  width: 230px;
  background: linear-gradient(30deg, #7d76ef, #d63f8c) !important;
}
body .van-toast .van-toast__icon {
  font-size: 50px;
}
*, :after, :before {
  box-sizing: border-box;
}
.van-dialog__header {
  font-size: 32px;
}
.van-dialog {
  width: fit-content !important;
  min-width: 75%;
  max-width: 90%;
}
.van-dialog__message {
  font-size: 30px !important;
  line-height: 1.8 !important;
  padding: 28px 12px !important;
  word-break: keep-all !important;
}
.van-dialog__confirm {
  height: fit-content !important;
  padding:20px !important;
  border-top: 1px solid #999 !important;
}
.van-dialog__confirm .van-button__text {
  font-size: 30px !important;
  color: #7d76ef;
}
.van-tabbar-item__text {
  text-align: center;
}
.notice-swiper{
  border-radius: 8px !important;
}
</style>
